<template>
  <!-- 全站语言切换。放在页面标题行最右端（CurrentDate.vue），手机宽度放进顶栏（Navbar.vue，compact）。
       按钮用地球图标 + 语言名（不用国旗：国旗代表国家不代表语言）；列表里保留国旗帮助辨认。 -->
  <div class="LanguageSwitch" :class="{ 'LanguageSwitch--compact': compact }">
    <el-popover placement="bottom-end" ref="popover"
        title="" width="" trigger="manual"
        popper-class="LanguagePopper" v-model="visible" content="">
      <div slot="reference" ref="reference">
        <el-tooltip :content="$t('sidebar.language')" placement="bottom" :disabled="visible || !compact">
          <button type="button" class="LanguageSwitch__btn" :class="{ 'is-open': visible }" @click="visible = !visible">
            <Icon name="internet" class="LanguageSwitch__icon"/>
            <span class="LanguageSwitch__label">{{ label }}</span>
            <i v-if="!compact" class="el-icon-arrow-down LanguageSwitch__caret"></i>
          </button>
        </el-tooltip>
      </div>
      <div class="contentBox">
        <div v-for="item in countryArr" :key="item.value" @click="changeLanguage(item)" :class="{activeList:activeLanguage===item.value}" class="countryList">
          <div class="langName">{{nativeName(item.value) || item.name}}</div>
          <Icon v-if="activeLanguage===item.value" name="check" class="langCheck"/>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { Icon } from "tdesign-icons-vue";
import { setLibredeskLanguage } from "@/utils/libredesk.js";

const NATIVE_NAMES = { en: 'English', de: 'Deutsch', zh: '中文', it: 'Italiano' };
// 手机顶栏位置小，用短写
const SHORT_NAMES = { en: 'EN', de: 'DE', zh: '中文', it: 'IT' };

export default {
  name: "LanguageSwitch",
  components: { Icon },
  props: {
    // 手机顶栏：地球图标 + 短写，无下拉箭头
    compact: { type: Boolean, default: false },
  },
  data(){
    return{
      visible:false,
      activeLanguage:"",
    }
  },
  computed:{
    countryArr(){
      return this.$t('countryArr')
    },
    label(){
      if (this.compact) return SHORT_NAMES[this.activeLanguage] || '';
      return this.nativeName(this.activeLanguage) || '';
    },
  },
  watch:{
    countryArr:{
      handler(){
        this.activeLanguage = this.$i18n.locale
      },
      immediate: true
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods:{
    nativeName(value) {
      return NATIVE_NAMES[value];
    },
    handleClickOutside(event) {
      if (!this.visible) return
      const triggerBtn = this.$refs.reference
      const popover = this.$refs.popover.$el
      const isClickInside = triggerBtn.contains(event.target) || popover.contains(event.target)
      if (!isClickInside) this.visible = false
    },
    changeLanguage(data){
      this.visible = false
      var lang = data.value
      this.$i18n.locale = lang
      localStorage.setItem('language', lang)
      setLibredeskLanguage(lang)
      document.documentElement.classList.forEach(c => { if (c.startsWith('lang-')) document.documentElement.classList.remove(c) })
      document.documentElement.classList.add('lang-' + lang)
    },
  },
}
</script>

<style scoped lang="scss">
/* 和页面上其他次要按钮同一套外观：白底、浅灰边框、8px 圆角、36px 高 */
.LanguageSwitch__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid var(--biz-border, #E5E7EB);
  border-radius: 8px;
  background: #fff;
  color: #374151;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;

  &:hover,
  &.is-open {
    background: var(--biz-hover-bg, #F5F7FA);
    border-color: var(--biz-border-hover, #1A365D);
  }
}
.LanguageSwitch__icon {
  width: 16px;
  height: 16px;
  color: #4B5563;
}
.LanguageSwitch__caret {
  font-size: 12px;
  color: #9CA3AF;
  transition: transform 0.2s;
}
.is-open .LanguageSwitch__caret {
  transform: rotate(180deg);
}

/* 标题行版本在手机宽度隐藏 —— 那时侧边栏收起，顶栏（Navbar.vue）里有紧凑版 */
@media (max-width: 1023px) {
  .LanguageSwitch:not(.LanguageSwitch--compact) {
    display: none;
  }
}

/* 手机顶栏：无边框，只有图标 + 短写 */
.LanguageSwitch--compact .LanguageSwitch__btn {
  height: 32px;
  padding: 0 8px;
  border-color: transparent;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  gap: 4px;
}
</style>
<style lang="scss">
.LanguagePopper{
  // 去掉国旗后只剩语言名 + 勾，和右上角的「🌐 English」按钮差不多宽，不再留一大块空白
  min-width: 128px !important;
  padding: 6px !important;
  .popper__arrow{
    display: none !important;
  }
  .countryList{
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    border-radius: 4px;
    padding: 8px 10px;
    .langName{
      flex: 1;
      font-family: Inter,Sans-serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #232323;
    }
    .langCheck{
      width: 16px;
      height: 16px;
      flex-shrink: 0;
      color: var(--sidebar-accent, #1A365D);
    }
  }
  .countryList:hover{
    background: var(--biz-hover-bg, #F5F7FA);
  }
  .activeList{
    background: var(--biz-hover-bg, #EBF8FF);
    .langName{
      font-weight: 600;
    }
  }
}
</style>
